﻿window.onload = function exampleFunction() {
    Process();
}
function PleaseWait() {
    const fancybox = new Fancybox([
      {
         src: "<div class='text-center'><p><img alt='please wait cursor' class='pleaseWaitCursor' src='https://humankinetics.myshopify.com/cdn/shop/files/loading.gif'></img></p><h3 class='accent-color'>Processing Request</h3> <p><strong>Please note that this may take a few minutes.</strong></p></div>",
         type: "html",
      },
    ]);
}
function HideWait() {
    Fancybox.close();
}
function ShowError(errorMsg) {
    const fancybox = new Fancybox([
      {
          src: "<p>" + errorMsg + "</p><p><a class='btn btn--primary' href='#' onClick='HideWait(); return false;'>Close</a></p>",
          type: "html",
          closeButton: true
      },
    ]);
}

function Process() {
    //get current subscriptions.
    $(document).ready(function () {
        var emailAddress = $("#emailAddress").val();
        var isLoggedInValue = $("#isLoggedIn").val();
        var isLoggedIn = false; 

        // Check and set isLoggedIn 
        if (isLoggedInValue === 'true') {
            isLoggedIn = true;
        }

        //check if customer is logged in.
        if (isLoggedIn) {
            PleaseWait();
            //get customer's current subscriptions.           
            $.ajax({
                type: "Get",
                dataType: "json",
                url: "https://dnext.humankinetics.com/Delivra/API/GetMemberSubscriptions?emailAddress=" + emailAddress, 
                contentType: "text/javascript",
                crossDomain: true,
                timeout: 60000,
                xhrFields: { withCredentials: true }
            })
            .done(function (data) {
                HideWait();
                var result = jQuery.parseJSON(data);
                // Process the subscriptions and check the checkboxes
                if (result.Success) {
                    var subscribed = jQuery.parseJSON(result.Message); // This parses the JSON string found in result.Message
                    subscribed.forEach(function (subscription) {
                        $("input:checkbox[name='newsletters'][value='" + subscription.ID + "']").prop("checked", true);
                    });
                }
            })    
            .fail(function (xhr, textStatus, errorThrown) {
                console.log(xhr);
                console.log(textStatus);
                console.log(errorThrown);
                HideWait();
                //call didn't succeed.
                ShowError("<p>Oops something went wrong. Please try again later</p><p><a href='/pages/contact-us'>Contact Us</a> if the error persists</p>");        
            });

        }
    });
}


//set subscriptions.
$(document).ready(function () {
    /*subscribe to atleast one newsletter.
    called when page.newsletter is submitted. */
    $('#newsletter-signup').submit(function () {
        //get the value of the selected country.
        //this country is not stored in Shopify it's only passed to Delivra. Why you ask?
        //because marketing wants to be able to filter subscriptions by country and Shopify doesn't require an address when someone registers for an account.
        var address = $('#address').val();
        var addressLine2 = $('#addressLine2').val();
        var city = $('#city').val();
        var state = $('#state').val();
        var zipCode = $('#zipCode').val();
        var company = $('#company').val();
        var phone = $('#phone').val();
        var emailAddress = $("#emailAddress").val();
        var firstName = $("#firstName").val();
        var lastName = $("#lastName").val();
        var isLoggedIn = $("#isLoggedIn").val();
        var selectedCountry = "";

        if ($("#country").length) {
            selectedCountry = $("#country").val();
            selectedCountry = $("select option:selected").text();
        }

        if ($("#countryNewsletter").length) {
            //Canada's form dropdowns are clashing with the language translation app so they countryNewsletter as the ID for the country dropdown
            selectedCountry = $("#countryNewsletter").val();
        }

        if (!selectedCountry) {
            ShowError("Please select your country");
            return false;
        }

        if (!emailAddress) {
            ShowError("<strong>Please enter your email address</strong>");
            return false;
        }

        if (!firstName) {
            ShowError("<strong>Please enter your first name</strong>");
            return false;
        }

        if (!lastName) {
            ShowError("<strong>Please enter your last name</strong>");
            return false;
        }

        var selected = [];
        var unselected = [];
        //get a list of checked and unchecked checkboxes.
        $('input:checkbox[name=newsletters]').each(function () {
            if ($(this).is(':checked'))
                selected.push($(this).val());
            else
                unselected.push($(this).val());
        });

        //Display error if nothing is selected.
        if (selected.length === 0) {
            ShowError("<p>Please select a newsletter</p>");
            return false;
        }

        //set customer details.
        var customer = {
            emailaddress: emailAddress,
            firstname: firstName,
            lastname: lastName,
            address: address,
            addressline2: addressLine2,
            city: city,
            state: state,
            zipcode: zipCode,
            country: selectedCountry,
            catalogueid: selected,
            unsubcatalogueid: unselected,
            fullname: firstName + " " + lastName,
            company: company,
            datejoined: "",
            phone: phone,
            profiletitle: ""
        };

        //convert the customer object to a json string.
        var customerJson = JSON.stringify(customer);
        if (isLoggedIn) {
            PleaseWait();
            //customer is logged in.
            $.ajax({
                type: "Get",
                dataType: "json",
                url: "https://dnext.humankinetics.com/Delivra/API/SetSubscription?userData=" + customerJson, 
                contentType: "text/javascript",
                crossDomain: true,
                timeout: 60000, //timeout after 60 seconds.
                xhrFields: { withCredentials: true }
            })
             .done(function (data) {
                 HideWait();
                 var resultObj = JSON.parse(data);
                 //call was successful.
                 if (resultObj.Success) {
                     //Display subscribe confirmation 
                     ShowError("<p>Thank you for subscribing to our newsletters.</p><p><a  href='/'>Continue shopping</a> </p>");
                 } else {
                     ShowError(resultObj.Message);
                 }
                 return false;
             })
             .fail(function (xhr, textStatus, errorThrown) {
                 console.log(xhr);
                 console.log(textStatus);
                 console.log(errorThrown);
                 HideWait();
                 ShowError("<p>Oops something went wrong. Please try again later</p><p><a href='/pages/contact-us'>Contact Us</a> if the error persists</p>");
             });

             return false;
        } else {
            PleaseWait();

            $.ajax({
                type: "Get",
                dataType: "json",
                url: "https://dnext.humankinetics.com/Delivra/API/SetSubscriptionNotLoggedIn?userData=" + customerJson,
                contentType: "text/javascript",
                crossDomain: true,
                timeout: 60000, //timeout after 60 seconds.
                xhrFields: { withCredentials: true }
            })
            .done(function (data) {
                HideWait();
                var resultObj = JSON.parse(data); 
                //call was successful.
                if (resultObj.Success) {
                    //Display subscribe confirmation 
                    ShowError("<p>Thank you for subscribing to our newsletters.</p><p><a  href='/'>Continue shopping</a> </p>");
                } else {
                    ShowError(resultObj.Message);
                }
            })
            .fail(function (xhr, textStatus, errorThrown) {
                console.log(xhr);
                console.log(textStatus);
                console.log(errorThrown);
                HideWait();
                //call didn't succeed.
                ShowError("<p>Oops something went wrong. Please try again later</p><p><a href='/pages/contact-us'>Contact Us</a> if the error persists</p>");
            });
            return false;
        }
    });//submitted form.
});//document ready

/*unsubscribe from all newsletters
  Click on the unsubscribe link on page.newsletters.
*/
function UnsubscribeUser(emailAddress) {
    var emailAddress = $("#emailAddress").val();
    if (!emailAddress) {
        ShowError("<strong>Please enter your email address</strong>");
        return false;
    }

    PleaseWait();
    $.ajax({
        type: "Get",
        dataType: "json",
        url: "https://dnext.humankinetics.com/Delivra/API/UnsubscribeAll?emailAddress=" + emailAddress,
        crossDomain: true,
        timeout: 60000, //timeout after 60 seconds.
        xhrFields: { withCredentials: true }
    })
    .done(function (data) {
        HideWait();
        var resultObj = JSON.parse(data);
        //call was successful.
        if (resultObj.Success) {
            //display unsubscribe confirmation.
            ShowError("<p>You have been successfully removed from HK Newsletter mailings.</p><p><a href='/'>Continue shopping</a></p>");
        } else {
            //call didn't succeed.
            ShowError(resultObj.Message);
        }
    })
    .fail(function (xhr, textStatus, errorThrown) {
        console.log(xhr);
        console.log(textStatus);
        console.log(errorThrown);
        HideWait();
        ShowError("<p>Oops something went wrong. Please try again later</p><p><a href='/pages/contact-us'>Contact Us</a> if the error persists</p>");
    });
    return false;
}

